import { Fragment } from "react/jsx-runtime";
import AddChargebreakdownDropzone from "./AddChargebreakdownDropzone";
import AddChargebreakdownFieldMapping from "./AddChargebreakdownFieldMapping";
import AddChargebreakdownVerify from "./AddChargebreakdownVerify";
import useAddChargebreakdown from "./hooks/useAddChargebreakdown";
import { useEffect } from "react";

const AddChargebreakdownMain = () => {
  const { currentStep, clearAllData } = useAddChargebreakdown();

  useEffect(() => {
    return () => {
      clearAllData();
    };
  }, []);
  return (
    <Fragment>
      {currentStep === "upload-chargebreakdown" && <AddChargebreakdownDropzone />}
      {currentStep === "map-chargebreakdown" && <AddChargebreakdownFieldMapping />}
      {currentStep === "verify-chargebreakdown" && <AddChargebreakdownVerify />}
    </Fragment>
  );
};

export default AddChargebreakdownMain;
